export type TClientRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export const getBoundingClientRect = (element: HTMLElement | null): TClientRect | null => {
  if (!element) {
    return null;
  }
  const rect = element.getBoundingClientRect();

  return {
    x: rect.x,
    y: rect.y,
    width: rect.width,
    height: rect.height,
  };
};
